function formatprice(divided){
  return divided.toLocaleString('da-DK', { minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'DKK' });      
}

function _updatepriceBox(){
  const selectedPrice = localStorage.getItem('selected-price')
    if (selectedPrice && selectedPrice === 'includeTax') {
      document.querySelectorAll('.product-price--original').forEach(elm => {
          elm.classList.remove('hidden');
      })

      document.querySelectorAll('.product-price--original__tax').forEach(elm => {
          elm.classList.add('hidden');
      })

      document.querySelectorAll('.product-price--compare').forEach(elm => {
          elm.classList.remove('hidden');
      })

      document.querySelectorAll('.product-price--compare__tax').forEach(elm => {
          elm.classList.add('hidden');
      })
  }
}
function slideOpen(loading = true) {
    document.querySelector('.wishlist-list').classList.remove('wishlist-list--open');
    document.querySelector('.wishlist-list').classList.add('wishlist-list--open');

    this.buble = document.querySelector('.wishlist-count-bubble')
    if(loading)
        document.querySelector('.wishlist-ProductGridContainer').innerHTML = 'Loading....';
    
    const arr = JSON.parse(localStorage.getItem('sa-wishlist')) || [];
    console.log(arr.length)
    if (arr.length) {
        if (document.querySelector('.wishlist-list_loading-overlay__spinner')) {
            document.querySelector('.wishlist-list_loading-overlay__spinner').classList.remove('hidden')
        }

      const promises = arr.map(handle => {
          return fetch(`/products/${handle}.js`)
            .then(response => response.json())
            .catch(error => error);
        });
        setTimeout(() => {document.querySelector('.wishlist-ProductGridContainer').innerHTML = ''}, 2000);

        Promise.all(promises)
        .then(products => {
          products.forEach((product) => {
            console.log(product)
            const divided = product.price / 100;
            const formated = formatprice(divided);
            const priceWithTax = product.price; // the total price including tax
            const taxRate = 0.25; // the tax rate as a decimal (25% = 0.25)
            const priceWithoutTax = priceWithTax / (1 + taxRate);
            const priceWithoutTaxFormated = formatprice(priceWithoutTax / 100);
            const jsonString = JSON.stringify(product);
            const productDiv = document.createElement('div');
            productDiv.setAttribute('id', `product-item-${product.id}`);
            productDiv.className = 'product-item card'
            productDiv.innerHTML = `<div>
    <a href="/products/${product.handle}" class="card__image product-item__image
    
    " style="padding-top:100.0%">
        <figure class="lazy-image lazy-image--background product-item__image-figure product-item__image-figure--primary lazy-image--animation lazyloaded" data-ratio="1.0" style="padding-top: 100.0%" data-crop="false">
            <img src="${product.featured_image}&amp;width=480" alt="${product.title}" onload="this.parentNode.classList.add('lazyloaded')">
        </figure>
    </a>
    <div class="card__text product-item__text gutter--regular spacing--xlarge remove-empty-space text-align--left">
        <div class="product-item__price text-size--large equalize-white-space">
            <div class="remove-line-height-space">
                <div class="product-price">
                    <span class="product-price--original " data-js-product-price-original="">${formated}</span>
                    <span class="product-price--original__tax " data-js-product-price-original="">${priceWithoutTaxFormated}<span class="product-item__price__tax"> ${formated} (inkl. moms)</span>
                    </span>
                    <del class="product-price--compare" data-js-product-price-compare=""></del>
                    <del class="product-price--compare__tax" data-js-product-price-compare=""></del>
                    <span class="product-price--unit text-size--regular" data-js-product-price-unit=""></span>
                </div>
            </div>
        </div>
        <a class="product-item__title" href="/products/runde-alu-daser-med-lag-100-ml-1-stk-round-aluminium-cans-with-lid-100ml-1-pcs" title="${product.title}">
            <div class="remove-line-height-space--small">
                <span class="text-animation--underline text-size--large text-line-height--small text-weight--bold text-animation--underline text-product--title">${product.title}</span>
            </div>
        </a>
        <div class="product-item__quick-buy">
            <quick-add-to-cart class="quick-add-to-cart">
                <product-form data-ajax-cart="">
                    <div class="quick-add-to-cart-button">
                        <form method="post" action="/cart/add" id="product_form_${product.id}" accept-charset="UTF-8" class="shopify-product-form" enctype="multipart/form-data">
                            <input type="hidden" name="form_type" value="product">
                            <input type="hidden" name="utf8" value="✓">
                            <input type="hidden" name="id" value="${product.variants[0].id}">
                            <button class="button button--outline button--regular button--fullwidth button--loader" data-js-product-add-to-cart="" type="submit" name="add">
                                <span class="button__text ">Læg i kurv</span>
                                <span class="button__preloader">
                                    <svg class="button__preloader-element" viewBox="25 25 50 50">
                                        <circle cx="50" cy="50" r="20" fill="none" stroke-width="4"></circle>
                                    </svg>
                                </span>
                            </button>
                        </form>
                    </div>
                </product-form>
            </quick-add-to-cart>
        </div>
        <wishlist-favorite class="filled">
            <script type="application/json">
                ${jsonString}
            </script>
            <a href="#" class="fs-sm link d-flex align-items-center">
                <svg width="30px" height="24px" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg" fill="#000000">
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                    <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                    <g id="SVGRepo_iconCarrier">
                        <g fill="none" fill-rule="evenodd">
                            <path d="m0 0h32v32h-32z"></path>
                            <path d="m29.784768 18.838435c2.1985878-3.0737402 2.215232-4.6673224 2.215232-7.1599086 0-3.8396034-3.504074-8.6785264-8.4317228-8.6785264s-7.5682772 2.90055339-7.5682772 2.90055339-2.6406284-2.90055339-7.56827721-2.90055339c-4.92764879 0-8.43172279 4.838923-8.43172279 8.6785264 0 3.8396033 1.83194611 7.6268851 5.12706376 10.4418366 3.29511764 2.8149515 5.49751934 4.4983953 7.87293624 5.9509354 2.3754169 1.45254 2.9500689 1.9353689 3 1.9285614 0 0 1.8187904-1.1116041 3-1.9285614 1.1812096-.8169574 2.5394341-1.7683558 2.5394341-1.7683558s6.0467462-4.3907674 8.2453339-7.4645076z" fill="#202327"></path>
                        </g>
                    </g>
                </svg>
                <span>Føj til dine favoritter </span>
            </a>
        </wishlist-favorite>
    </div>
    <div class="product-item__badges text-size--xsmall"></div>
</div>`;
            document.getElementById('product-container').appendChild(productDiv);
            
            
          })
        })
        .then(() => _updatepriceBox())
        .catch(error => {
            // Handle any errors that occur during the fetch operations
            console.error(error);
        });
    }
    else {
        document.querySelector('.wishlist-ProductGridContainer').innerHTML = 'No collection found!';
        
        if (document.querySelector('.wishlist-list_loading-overlay__spinner')) {
            document.querySelector('.wishlist-list_loading-overlay__spinner').classList.add('hidden')
        }
    }

    
}
class FavoriteWishlist extends HTMLElement {
    constructor() {
        super();
        // this.storage = localStorage.getItem('sa-favorite')
        this.element = this.closest('wishlist-favorite')
        this.buble = document.querySelector('.wishlist-count-bubble')
        this.addEventListener('click', (evt) => {
            evt.preventDefault();
            const scriptEl = this.element.querySelector('script');
            if (scriptEl) {
                const textJson = JSON.parse(scriptEl.textContent);
                console.log(textJson)
                this.save(textJson?.handle || textJson.sku);
              
            }
        });

        if(document.querySelector('[data-close-wishlist]'))
        document.querySelector('[data-close-wishlist]').addEventListener('click', (evt) => this.close().bind(this));
        
        this.init();
    }
   
    init() {
        const wishlist = JSON.parse(localStorage.getItem('sa-wishlist')) || [];
        const arr = wishlist.filter(value => value !== null);

        const scriptEl = this.element.querySelector('script');
        if (scriptEl) {
            const textJson = JSON.parse(scriptEl.textContent);
            if (textJson?.sku && arr.includes(textJson.sku)) { 
                this.element.classList.add('filled');
            }

            if (textJson?.handle && arr.includes(textJson.handle)) { 
                this.element.classList.add('filled');
            }
        }
    }

    save(newItem) {
        // Get the current wishlist from localStorage
        const wishlist = JSON.parse(localStorage.getItem('sa-wishlist')) || [];

        // Add a new item to the wishlist only if it's not already present
       // console.log(newItem)
       // console.log(wishlist)
        // console.log(wishlist.includes(newItem))
        let remove = false;
        if (!wishlist.includes(newItem)) {
            wishlist.push(newItem);
        }
        else {
            const index = wishlist.indexOf(newItem);
            if (index !== -1) {
                wishlist.splice(index, 1); // remove the item at the found index
                remove = true;
            }
        }

        const arr = wishlist.filter(value => value !== null);
        // Save the updated wishlist to localStorage
        localStorage.setItem('sa-wishlist', JSON.stringify(arr));

       if(!remove) this.element.classList.add('filled'); else this.element.classList.remove('filled');

        if(this.buble) this.buble.innerHTML = arr.length;
        //console.log(this.buble)
        //console.log(arr)
        // this.open();

        
        if (document.querySelector('.personal-lists')) {
            //console.log('WISHLIST PAGE', document.querySelector('.personal-lists'))
            //document.querySelectorAll('#product-container').forEach(t => t.innerHTML = '')
            //console.log(document.querySelectorAll('#product-container'));
            //setTimeout(() => this.open(false) , 1000)

           // this.element.closest('.product-item').closest('div').remove()
            const div2Remove = this.element.closest('.product-item')
            div2Remove.closest('div').remove();
            if(arr.length <= 0){
              setTimeout(() => this.open(false) , 1000)
            }
        }
    }

    open(loading = true) {
        slideOpen(loading);
    }

    close() {
        document.querySelector('.wishlist-list').classList.remove('wishlist-list--open');
    }
    
  }
  
  customElements.define('wishlist-favorite', FavoriteWishlist);
  